import { Modal, Divider, Row, Space, Col, Button } from "antd";
import { Form, Formik } from "formik";
import { initialValues, CalendarSchema } from "../schemas/holidaySchema";
import styles from "components/elements/Modal/Modal.module.css";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Input } from "components/form";

function HolidayCalendarModal({

    title = "",
    isModalOpen = false,
    className = "",
    width = 500,
    onCancel = () => { },
    handleOk = () => { },
    handleOnCalendarSubmit = () => { },
    currentCalendar = {},
}) {
    console.log("modal ", isModalOpen);
    const { t } = useTranslation()
    return (
        <Modal
            title={currentCalendar?.calendarName ? t("common.edit") : t("common.create")}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={() => {
                const cancelBtn = document.getElementById(
                    "year_accumulate_cancelBtn"
                );
                if (cancelBtn) {
                    cancelBtn.click();
                } else {
                    onCancel();
                }
            }}
            className={cx(styles.customStyle, className)}
            width={width}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Formik
                enableReinitialize
                initialValues={{ ...initialValues, ...currentCalendar }

                }
                validationSchema={CalendarSchema}
                onSubmit={(values) => {
                    const requestBody = {
                        ...values,
                    };
                    handleOnCalendarSubmit(requestBody, onCancel)
                }}
            >
                {({ values = {}, setFiedValue = () => { }, resetForm = () => { } }) => {

                    console.log("modal values ", values);
                    return (
                        <Form>
                            <Space
                                className={styles.container}
                                size={24}
                                direction="vertical"
                            >
                                <Row gutter={[0, 16]}>
                                    <Col span={24}>
                                        <Input
                                            name="calendarName"
                                            label={t('calendar-nameTH')}
                                            placeholder={t('calendar-nameTH')}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Input
                                            name="calendarNameEn"
                                            label={t('calendar-nameEN')}
                                            placeholder={t('calendar-nameEN')}
                                            size="large"
                                        />
                                    </Col>
                                </Row>
                                <Row justify="end">
                                    <Space direction="horizontal" size={12}>
                                        <Button
                                            id="organization__cancelBtn"
                                            key="back"
                                            onClick={() => {
                                                onCancel();
                                                resetForm();
                                            }}
                                            style={{ borderRadius: "8px", height: "40px" }}
                                        // className={styles.cancelContainer}
                                        >
                                            {t('holiday.cancel')}
                                        </Button>
                                        <Button
                                            htmlType="submit"
                                            type="primary"
                                            // className={styles.cancelSave}
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                        >
                                            {t('holiday.save')}
                                        </Button>
                                    </Space>
                                </Row>


                            </Space>
                        </Form>
                    );
                }}
            </Formik>

        </Modal>
    )
}

export default HolidayCalendarModal